import { useMemo } from 'react';
import { useChainId } from './chain';
import { useStores } from './store-selection/queries/useStores';
import { useStorefrontType } from './style-timeline/useStorefrontType';
import { useStoreType } from './useStoreType';

export const useChainStores = () => {
    const { stores } = useStores();
    const chainId = useChainId();
    const storeType = useStoreType();
    const storefrontType = useStorefrontType();

    const chainStores = useMemo(() => {
        if (!stores || !chainId || !storeType || !storefrontType) {
            return [];
        }
        return stores.filter(
            (store) =>
                store.chainId === chainId && store.storeType === storeType && store.storefrontType === storefrontType
        );
    }, [stores, chainId, storeType, storefrontType]);

    return chainStores;
};
